var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,3H19V1H17V3H7V1H5V3H4A2.00588,2.00588,0,0,0,2,5V21a2.00588,2.00588,0,0,0,2,2H20a2.00588,2.00588,0,0,0,2-2V5A2.00588,2.00588,0,0,0,20,3Zm0,18H4V8H20Z",
    transform: "translate(-2 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82715,16.9209l.58887-.78027a3.41334,3.41334,0,0,0,.85156.62988,2.19555,2.19555,0,0,0,1.01953.23437,1.6273,1.6273,0,0,0,1.07422-.34277,1.12669,1.12669,0,0,0,.41406-.918A1.63469,1.63469,0,0,0,9,14.35254v-.89941c1.22618,0,1.51172-.646,1.51172-1.38254a1.04025,1.04025,0,0,0-.32422-.81006,1.27214,1.27214,0,0,0-.8877-.29395,2.27046,2.27046,0,0,0-1.57226.74414l-.63574-.75635a3.33924,3.33924,0,0,1,2.25586-.96,2.67993,2.67993,0,0,1,1.73437.52832,1.76491,1.76491,0,0,1,.65332,1.45166,1.92449,1.92449,0,0,1-1.35547,1.86155v.04883a2.27141,2.27141,0,0,1,1.16992.67773A1.7847,1.7847,0,0,1,12,15.80469a1.98756,1.98756,0,0,1-.34863,1.16992,2.21724,2.21724,0,0,1-.94141.76172A3.23825,3.23825,0,0,1,9.38379,18,3.27569,3.27569,0,0,1,6.82715,16.9209Z",
    transform: "translate(-2 -1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,17h1.00075V11.5H14v-1a2.83748,2.83748,0,0,0,1.30055-.5H16v7h1v1H14Z",
    transform: "translate(-2 -1)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.d55aed74.svg";
export { ForwardRef as ReactComponent };